module.exports = __webpack_public_path__ + "img/historial-medico.820a6a5e.png";